import { render } from "./ParserProcess.vue?vue&type=template&id=4c36a4e1&scoped=true"
import script from "./ParserProcess.vue?vue&type=script&lang=js"
export * from "./ParserProcess.vue?vue&type=script&lang=js"

import "./ParserProcess.vue?vue&type=style&index=0&id=4c36a4e1&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c36a4e1"]])

export default __exports__